import { BookingEntity } from 'Models/Entities';
import { ferryBookingToWizardData } from 'Util/_HumanWritten/BookingWizard/FerryBookingToWizardDataUtils';
import { isNotNullOrUndefined, isNullOrUndefined } from 'Util/TypeGuards';
import { BookingWizardData } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardData/BaseBookingWizardData';
import { SelectedTrips } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/BookingWizardWrap';
import { tripSummaryLocationType } from 'Views/Components/_HumanWritten/BookingWizard/FerryTripBookingWizard/WizardSteps/Cart/TripBookingSummaryCard';

export const calculateBookingsToDisplay = (
	currentBookings: BookingEntity[],
	cartView: boolean,
	afterPayment: boolean,
	isAlteration: boolean,
	tripSummaryLocation: tripSummaryLocationType,
	wizardData?: BookingWizardData,
	selectedTrips?: SelectedTrips,
	alterReturn?: boolean,
) => {
	return cartView || afterPayment
		? ferryBookingToWizardData(
				currentBookings,
				undefined,
				undefined,
				isAlteration,
				tripSummaryLocation === 'check-in'
					? alterReturn
					: (isNotNullOrUndefined(wizardData) &&
							(wizardData?.departureTrip === undefined || wizardData.returningTicketId !== '')) ||
							(isAlteration &&
								isNullOrUndefined(wizardData) &&
								currentBookings[0]?.returnBooking !== null) ||
							!isAlteration,
			)
		: ferryBookingToWizardData(
				currentBookings,
				wizardData,
				selectedTrips,
				isAlteration,
				(isNotNullOrUndefined(wizardData) &&
					(wizardData?.departureTrip === undefined || wizardData.returningTicketId !== '')) ||
					!isAlteration ||
					alterReturn,
			);
};
